<template>
  <article id="article-portfolio">
    <section
      id="section-top-holdings"
      v-if="arrTopHoldings && arrTopHoldings.assets && arrTopHoldings.assets.length > 0"
    >
      <header class="header-port">
        <h2>TOP 5 Holdings</h2>
        <span>({{ arrTopHoldings.data_date | dateFilter }})</span>
      </header>
      <div class="pie-chart">
        <pie-chart :id="'top-holding-chart'" :data="arrTopHoldings.assets" />
      </div>
      <ul class="port-list">
        <li class="port-item" :key="index" v-for="(item, index) in arrTopHoldings.assets">
          <div class="port-row">
            <div class="port-col-first" :style="{ color: computeColor(index)}">
              <i class="fas fa-circle"></i>
            </div>
            <div class="port-col-second">
              {{ item.name }}
              <router-link
                data-action="open_stock"
                data-listname="fund_top_holding"
                :data-stockname="item.short_code"
                class="external-link"
                :to="{name: 'miniapp-stock-quote', query: {name: item.short_code }}"
                v-if="item.link_url"
              >
                <i class="far fa-external-link-alt"></i>
              </router-link>
            </div>
            <div class="port-col-third">{{ item.percent ? numberToFixed(item.percent) : '' }}%</div>
          </div>
        </li>
      </ul>
    </section>

    <section
      id="section-asset-classes"
      v-if="arrAssetClasses && arrAssetClasses.assets && arrAssetClasses.assets.length > 0"
    >
      <header class="header-port">
        <h2>Asset Classes</h2>
        <span>({{arrAssetClasses.date | dateFilter }})</span>
      </header>
      <div class="pie-chart">
        <pie-chart :id="'asset=classes-chart'" :data="arrAssetClasses.assets" />
      </div>
      <ul class="port-list">
        <li class="port-item" :key="index" v-for="(item, index) in arrAssetClasses.assets">
          <div class="port-row">
            <div class="port-col-first" :style="{ color: computeColor(index)}">
              <i class="fas fa-circle"></i>
            </div>
            <div class="port-col-second">{{ item.name }}</div>
            <div class="port-col-third">{{ item.percent ? numberToFixed(item.percent) : '' }}%</div>
          </div>
        </li>
      </ul>
    </section>

    <section
      id="section-sectors"
      v-if="arrSectors && arrSectors.assets && arrSectors.assets.length > 0"
    >
      <header class="header-port">
        <h2>Sectors</h2>
        <span>({{arrSectors.date | dateFilter }})</span>
      </header>
      <div class="pie-chart">
        <pie-chart :id="'sector-chart'" :data="arrSectors.assets" />
      </div>
      <ul class="port-list">
        <li
          class="port-item"
          :key="index"
          v-for="(item, index) in arrSectors.assets"
          data-action="open_stock"
          data-listname="fund_top_holding"
          :data-stockname="item.name"
        >
          <div class="port-row">
            <div class="port-col-first" :style="{ color: computeColor(index)}">
              <i class="fas fa-circle"></i>
            </div>
            <div class="port-col-second">{{ item.name }}</div>
            <div class="port-col-third">{{ item.percent ? numberToFixed(item.percent) : '' }}%</div>
          </div>
        </li>
      </ul>
    </section>
  </article>
</template>
<script>
import { mapActions } from "vuex";
import messages from "../../../utils/messages.js";
import PieChart from "../../../components/miniapp/global/PieChart.vue";
export default {
  components: {
    PieChart
  },
  data() {
    return {
      arrTopHoldings: [],
      arrAssetClasses: [],
      arrSectors: [],
      colorPalette: [
        "#fc4949",
        "#4bc91c",
        "#1e1ae3",
        "#41d7f4",
        "#14a6ff",
        "#bababa",
        "#6c84bd",
        "#569adc",
        "#7db5bd",
        "#3c5388",
        "#2667a8"
      ]
    };
  },
  props: {
    id: {
      type: String,
      default: ""
    }
  },
  filters: {
    dateFilter: function(value) {
      var options = {
        year: "2-digit",
        month: "short",
        day: "numeric"
      };

      if (value) {
        return new Date(value).toLocaleDateString("th-TH", options);
      }

      return "";
    }
  },
  watch: {
    async id(id) {
      await this.queryData(id);
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  async mounted() {
    if (this.id) {
      await this.queryData(this.id);
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    ...mapActions("fund", ["findFundTopHoldings", "findFundBreakdown"]),
    async queryData(id) {
      let rs_top_holdings = await this.findFundTopHoldings(id);
      this.arrTopHoldings = rs_top_holdings ? rs_top_holdings : [];

      let rs_breakdown = await this.findFundBreakdown(id);
      if (rs_breakdown) {
        let data = rs_breakdown.assetallocationbreakdown;
        data.assets = data.assets.filter(x => x.percent && Number(x.percent) > 0);
        for (let i = 0; i < data.assets.length; i++) {
          data.assets[i].name = messages.th[data.assets[i].name];
          data.assets[i].percent = Number(data.assets[i].percent).toFixed(2);
        }
        data.assets = data.assets.sort((a, b) =>
          a.percent > b.percent ? -1 : b.percent > a.percent ? 1 : 0
        );
        this.arrAssetClasses = data;

        let data_sectors = rs_breakdown.gobalstocksectorbreakdown;
        data_sectors.assets = data_sectors.sectors;
        data_sectors.assets = data_sectors.assets.filter(x => x.percent && Number(x.percent) > 0);
        for (let i = 0; i < data_sectors.assets.length; i++) {
          data_sectors.assets[i].name = messages.th[data_sectors.assets[i].name];
          data_sectors.assets[i].percent = Number(data_sectors.assets[i].percent).toFixed(2);
        }
        data_sectors.assets = data_sectors.assets.sort((a, b) =>
          a.percent > b.percent ? -1 : b.percent > a.percent ? 1 : 0
        );
        this.arrSectors = data_sectors;
      }
    },
    translateName(name) {
      return messages.th[name];
    },
    numberToFixed(num) {
      return num ? parseFloat(num).toFixed(2) : 0;
    },
    computeColor(num) {
      let colors = this.colorPalette;
      return this.colorPalette[num % colors.length] || "";
    }
  }
};
</script>
<style lang="scss" scoped>
#article-portfolio {
  @extend %container-style;
  #section-top-holdings {
    margin: 20px 0;
    display: inline-block;
    width: 100%;
    border-radius: 4px;
    border: solid 1px $color-border;
  }
  #section-asset-classes {
    margin: 20px 0;
    display: inline-block;
    width: 100%;
    border-radius: 4px;
    border: solid 1px $color-border;
  }
  #section-sectors {
    margin: 20px 0;
    display: inline-block;
    width: 100%;
    border-radius: 4px;
    border: solid 1px $color-border;
  }
  .external-link {
    color: $color-orange-finno;
    margin-left: 5px;
  }
  .header-port {
    padding: 8px;
    h2 {
      @extend %font-size-m;
      color: $color-normal-text;
      display: inline-block;
    }
    span {
      margin-left: 10px;
      @extend %font-size-ss;
      color: $color-secondary-text;
    }
  }
  .pie-chart {
    @include multipleResponsive(phablet, tablet) {
      @include finCol(4, 12, 16px, top, true, true);
    }
    border-top: 1px solid $color-border;
    padding: 8px;
  }
  .port-list {
    @include multipleResponsive(phablet, tablet) {
      @include finCol(8, 12, 16px, middle, true, true);
    }
    list-style: none;
    margin: 0;
    padding: 0;
    .port-item {
      margin: 0;
      border-top: 1px solid $color-border;
    }
  }
  .port-row {
    padding: 8px 0 8px 0;
    .port-col-first {
      @include finCol(1, 12, 0px, middle, true, true);
      padding: 0 5px;
      text-align: center;
      line-height: 0px;
      i {
        font-size: 8px;
      }
    }
    .port-col-second {
      @include finCol(8, 12, 0px, middle, true, true);
      @extend %font-size-ss;
      color: $color-normal-text;
    }
    .port-col-third {
      @include finCol(3, 12, 0px, middle, true, true);
      @extend %font-size-ss;
      font-weight: bold;
      color: $color-normal-text;
      text-align: right;
      padding: 0 17px;
    }
  }
}
</style>